// ===============================
// TODO: Uncomment this file when we fix https://secondstep.atlassian.net/browse/LEARN-24976, hiding this banner for now as the ssapi isn't working as expected
// ===============================
// import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
// import MspBullyingUnitNotification from './component'
// import { COOKIE_NAME } from './constants'
// import { getCookie, setCookie } from 'utils/cookiesHelper'
import {
  getMSOptInData,
  // calculateSitesWithBullyingUnitOnCount,
} from 'utils/siteData'
import siteOperations from 'store/siteManager/operations'

export const MspBullyingUnitNotificationContainer = ({
  mspSiteContexts,
  updateMSPOptIn,
}) => {
  // const [isModalOpen, setIsModalOpen] = useState(false)
  // const [isNotificationShowing, setIsNotificationShowing] = useState(false)

  // useEffect(() => {
  //   const shouldDisplayNotification = !getCookie(COOKIE_NAME)
  //   setIsNotificationShowing(shouldDisplayNotification)
  // }, [])

  // const handleDismissNotification = () => {
  //   setCookie(COOKIE_NAME, true, 365)
  //   setIsNotificationShowing(false)
  // }

  // const handleCloseModal = () => setIsModalOpen(false)

  // const handleOnSave = async mspOptInArr => {
  //   await updateMSPOptIn(mspOptInArr)
  //   handleCloseModal()
  // }

  // const hasMsp = mspSiteContexts?.length > 0
  // const hasMultipleSites = mspSiteContexts?.length > 1
  return null
  // return (
  //   isNotificationShowing &&
  //   hasMsp && (
  //     <MspBullyingUnitNotification
  //       handleCloseModal={handleCloseModal}
  //       handleDismissNotification={handleDismissNotification}
  //       handleOnSave={handleOnSave}
  //       handleOpenModal={() => setIsModalOpen(!isModalOpen)}
  //       hasMultipleSites={hasMultipleSites}
  //       isModalOpen={isModalOpen}
  //       mspSiteContexts={mspSiteContexts}
  //       sitesWithBullyingUnitOnCount={calculateSitesWithBullyingUnitOnCount(
  //         mspSiteContexts,
  //       )}
  //     />
  //   )
  // )
}

MspBullyingUnitNotificationContainer.propTypes = {
  mspSiteContexts: PropTypes.array,
  updateMSPOptIn: PropTypes.func,
}

const mapDispatchToProps = {
  updateMSPOptIn: siteOperations.updateMSPOptIn,
}
const mapStateToProps = ({ licenseManager, ssapiManager }) => {
  const v4Sites = ssapiManager.sites
  const v3Sites = licenseManager.sites
  const sites = v4Sites || v3Sites
  return {
    mspSiteContexts: getMSOptInData(sites), // This function has a translation from v4 sites back into v3 sites so the compoents continue to work
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MspBullyingUnitNotificationContainer)
